import ColorPalette from "../../../../../../docs/styling/theme";
import * as React from 'react';
export default {
  ColorPalette,
  React
};